export default __webpack_public_path__ + "static/media/cyclos-swap.3fdb84d5.svg";